//--------------------------------------------------------------------------
// <copyright file="MicrosoftLogo.js" company="Microsoft">
// Copyright (c) Microsoft Corporation. All rights reserved.
// </copyright>
//--------------------------------------------------------------------------
import microsoftLogo from'../images/MicrosoftLogo.png';

/// <summary>
/// Wrapper over Microsoft Logo img.
/// </summary>
const MicrosoftLogo = () => {
  return (
     <img  src={microsoftLogo} className="Dialog-microsoft-logo" alt="MicrosoftLogo"/>
  )
}

export default MicrosoftLogo
